import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import { useEffect } from 'react';
import { drawsOwnLoadFailure } from 'store/api/portalAPI';

/**
 * For a record page of the new design, which draws a load that fails with no record to keep as its own error state
 * with Retry: that read raises no toast, as the state says it all. Once the page has a record on screen a failed
 * reload leaves it there, so the toast is the only place the failure is said and it stays.
 *
 * A missing or forbidden record still goes to /404: the handler redirects before it looks for a toast.
 */
export const useDrawsOwnLoadFailure = (
    endpointName: string,
    recordId: string | number | undefined,
    hasRecord: boolean
): void => {
    const isNew = useIsNewDesign();
    // Registered in the pass of effects that sends the page's first read, so before that read can fail.
    useEffect(
        () => (isNew && recordId && !hasRecord ? drawsOwnLoadFailure(endpointName, recordId) : undefined),
        [isNew, endpointName, recordId, hasRecord]
    );
};
